import ProductLink from './ProductLink';

const ProductTitle = (props) => {
  const { product, displayType, hasLink = true } = props;
  switch (displayType) {
    case 'Detail':
      return product.title;
    case 'Personalization Block':
    case 'Collection':
      if (hasLink) {
        return (
          <ProductLink displayType={displayType} product={product}>
            {product.title}
          </ProductLink>
        );
      }
      return product.title;
    case 'List':
      if (hasLink) {
        return (
          <ProductLink displayType={displayType} product={product}>
            {product.title}
          </ProductLink>
        );
      }
      return product.title;
    default:
      return null;
  }
};

export default ProductTitle;
